export default __webpack_public_path__ + "2ab6b84263ba6b6611885f080d159ddc.png";